import { ImportCsvRequest, ImportCsvResponse, SuccessResponse, Tank } from '@/types'
import { CreateTankRequest } from '@/types/apis/tanks/createTankRequest'
import { GetAllTanksResponse } from '@/types/apis/tanks/getAllTankResponse'
import { GetTankRequest } from '@/types/apis/tanks/getTankRequest'
import { UpdateTankRequest } from '@/types/apis/tanks/updateTankRequest'

import axios from './axios'

const API_ENDPOINT = '/tank'

export const getAllTanksApi = ({ limit, page }: { limit?: number; page?: number }): Promise<GetAllTanksResponse> => {
  return axios.get(`${API_ENDPOINT}?limit=${limit}&page=${page}`)
}

export const getTanksApi = (): Promise<Tank[]> => {
  return axios.get(`${API_ENDPOINT}/all`)
}

export const getTankApi = (request?: GetTankRequest): Promise<Tank> => {
  return axios.get(`${API_ENDPOINT}/${request?.id}`)
}

export const createTankApi = (request: CreateTankRequest): Promise<SuccessResponse> => {
  return axios.post(API_ENDPOINT, request)
}

export const updateTankApi = (request: UpdateTankRequest): Promise<SuccessResponse> => {
  return axios.put(`${API_ENDPOINT}/${request.id}`, request)
}

export const deleteTankApi = (request: GetTankRequest): Promise<SuccessResponse> => {
  return axios.delete(`${API_ENDPOINT}/${request.id}`)
}

export const importTankApi = (request: ImportCsvRequest): Promise<ImportCsvResponse> => {
  return axios.post(`${API_ENDPOINT}/import-csv`, request)
}
